import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgBodyFoot = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.1117 7.19585C10.6679 7.09728 10.2076 7.09964 9.76473 7.20275C9.32191 7.30586 8.90789 7.5071 8.55323 7.79161C8.19858 8.07612 7.91233 8.43664 7.71563 8.84656C7.51893 9.25648 7.41679 9.70534 7.41675 10.16C7.41673 10.9008 7.62302 11.6269 8.01247 12.257C8.40193 12.8871 8.95917 13.3963 9.62175 13.7275C10.4615 14.1476 11.1678 14.7931 11.6614 15.5919C12.1551 16.3906 12.4166 17.311 12.4167 18.25C12.4167 19.0788 12.746 19.8737 13.332 20.4597C13.9181 21.0458 14.7129 21.375 15.5417 21.375C16.3705 21.375 17.1654 21.0458 17.7515 20.4597C18.3375 19.8737 18.6667 19.0788 18.6667 18.25V12.8858C18.6667 11.7481 18.2785 10.6443 17.5664 9.75692C16.8543 8.86952 15.8608 8.25153 14.7501 8.00501L11.1117 7.19585Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.91675 4.5C4.91675 4.99728 5.11429 5.47419 5.46592 5.82582C5.81755 6.17746 6.29447 6.375 6.79175 6.375C7.28903 6.375 7.76594 6.17746 8.11757 5.82582C8.4692 5.47419 8.66675 4.99728 8.66675 4.5C8.66675 4.00272 8.4692 3.52581 8.11757 3.17417C7.76594 2.82254 7.28903 2.625 6.79175 2.625C6.29447 2.625 5.81755 2.82254 5.46592 3.17417C5.11429 3.52581 4.91675 4.00272 4.91675 4.5V4.5Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.1667 3.875C11.1667 4.03915 11.1991 4.2017 11.2619 4.35335C11.3247 4.50501 11.4168 4.64281 11.5329 4.75888C11.6489 4.87496 11.7867 4.96703 11.9384 5.02985C12.0901 5.09267 12.2526 5.125 12.4167 5.125C12.5809 5.125 12.7434 5.09267 12.8951 5.02985C13.0468 4.96703 13.1846 4.87496 13.3006 4.75888C13.4167 4.64281 13.5088 4.50501 13.5716 4.35335C13.6344 4.2017 13.6667 4.03915 13.6667 3.875C13.6667 3.71085 13.6344 3.5483 13.5716 3.39665C13.5088 3.24499 13.4167 3.10719 13.3006 2.99112C13.1846 2.87504 13.0468 2.78297 12.8951 2.72015C12.7434 2.65733 12.5809 2.625 12.4167 2.625C12.2526 2.625 12.0901 2.65733 11.9384 2.72015C11.7867 2.78297 11.6489 2.87504 11.5329 2.99112C11.4168 3.10719 11.3247 3.24499 11.2619 3.39665C11.1991 3.5483 11.1667 3.71085 11.1667 3.875V3.875Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.1667 5.125C16.1667 5.45652 16.2984 5.77446 16.5329 6.00888C16.7673 6.2433 17.0852 6.375 17.4167 6.375C17.7483 6.375 18.0662 6.2433 18.3006 6.00888C18.5351 5.77446 18.6667 5.45652 18.6667 5.125C18.6667 4.79348 18.5351 4.47554 18.3006 4.24112C18.0662 4.0067 17.7483 3.875 17.4167 3.875C17.0852 3.875 16.7673 4.0067 16.5329 4.24112C16.2984 4.47554 16.1667 4.79348 16.1667 5.125V5.125Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgBodyFoot.displayName = 'SvgBodyFoot';
export default SvgBodyFoot;
